/* ============================================================
   Swiza Build Your Cornet
   + button adds ~100g worth of pieces (rounded to whole pieces)
   Price: based on actual pieces added × piece price
   Each click fills one "slot" of 100g in the box
   ============================================================ */

(function () {
  const dataEl = document.getElementById('swz-cornet-data');
  if (!dataEl) return;

  let data;
  try { data = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('Swiza Cornet — data parse failed', e); return; }

  const STEP_GRAMS = 100; // each click adds ~100g

  // Fixed per-gram rate in cents (EGP × 100)
  // Signature: 1,975 EGP/kg = 197.5 cents/g
  // Prestige:  2,250 EGP/kg = 225   cents/g
  const RATE_PER_GRAM = {
    signature: 197.5,
    prestige:  225
  };

  function ratePerGram(c) {
    return c.collection === 'prestige' ? RATE_PER_GRAM.prestige : RATE_PER_GRAM.signature;
  }

  function piecePriceCents(c) {
    const pieceG = (c.grams && c.grams > 0) ? c.grams : 20;
    return pieceG * ratePerGram(c);
  }

  // How many pieces for ~100g, rounded to nearest whole number (min 1)
  function piecesForStep(c) {
    const pieceG = (c.grams && c.grams > 0) ? c.grams : 20;
    return Math.max(1, Math.round(STEP_GRAMS / pieceG));
  }

  function parseCapacity(title) {
    const m = String(title).match(/(\d+(?:\.\d+)?)\s*(kg|g)\b/i);
    if (!m) return 500;
    const num = parseFloat(m[1]);
    return m[2].toLowerCase() === 'kg' ? Math.round(num * 1000) : Math.round(num);
  }

  (data.boxes || []).forEach(b => { b.capacity = parseCapacity(b.title); });

  const state = {
    box: (data.boxes && data.boxes[0]) || null,
    filter: 'all',
    items: {} // { variant_id: pieces }
  };

  const $boxes = document.getElementById('swz-boxes');
  const $tabs = document.getElementById('swz-tabs');
  const $grid = document.getElementById('swz-grid');
  const $grams = document.getElementById('swz-grams');
  const $count = document.getElementById('swz-count');
  const $bar = document.getElementById('swz-bar');
  const $total = document.getElementById('swz-total');
  const $addBtn = document.getElementById('swz-add-to-cart');

  if (!$boxes || !$grid) return;

  function gramsFor(c, pieces) {
    const pieceG = (c.grams && c.grams > 0) ? c.grams : 20;
    return pieces * pieceG;
  }

  function totalG() {
    let g = 0;
    Object.entries(state.items).forEach(([id, pieces]) => {
      const c = (data.chocolates || []).find(x => x.variant_id === parseInt(id));
      if (c && pieces > 0) g += gramsFor(c, pieces);
    });
    return g;
  }

  function totalP() {
    let p = 0;
    Object.entries(state.items).forEach(([id, pieces]) => {
      const c = (data.chocolates || []).find(x => x.variant_id === parseInt(id));
      if (c && pieces > 0) p += pieces * piecePriceCents(c);
    });
    return p;
  }

  function totalN() {
    return Object.values(state.items).filter(p => p > 0).length;
  }

  function totalPieces() {
    return Object.values(state.items).reduce((a, b) => a + b, 0);
  }

  // Count how many 100g "slots" are used based on actual grams
  function totalSlots() {
    return Math.round(totalG() / STEP_GRAMS);
  }

  function formatCurrency(cents) {
    return (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  function renderBoxes() {
    if (!data.boxes || data.boxes.length === 0) {
      $boxes.innerHTML = '<div class="swz-empty"><strong>No box sizes found.</strong></div>';
      return;
    }
    $boxes.innerHTML = data.boxes.map(b => {
      const active = state.box && state.box.variant_id === b.variant_id;
      const slots = Math.round(b.capacity / STEP_GRAMS);
      const imgHtml = b.image
        ? '<div class="swz-box-img"><img src="' + escapeAttr(b.image) + '" alt="" loading="lazy"></div>'
        : '<div class="swz-box-img swz-box-img--empty"></div>';
      return '<div class="swz-box ' + (active ? 'active' : '') + '" data-id="' + b.variant_id + '">' +
        imgHtml +
        '<div class="swz-box-title">' + escapeHtml(b.title) + '</div>' +
        '<div class="swz-box-cap">' + b.capacity + 'g · up to ' + slots + ' flavours</div>' +
        '</div>';
    }).join('');

    $boxes.querySelectorAll('.swz-box').forEach(el => {
      el.addEventListener('click', () => {
        const id = parseInt(el.dataset.id);
        state.box = data.boxes.find(b => b.variant_id === id);
        renderBoxes();
        renderGrid();
        renderSummary();
      });
    });
  }

  function bindTabs() {
    if (!$tabs) return;
    $tabs.querySelectorAll('.swz-tab').forEach(el => {
      el.addEventListener('click', () => {
        state.filter = el.dataset.f;
        $tabs.querySelectorAll('.swz-tab').forEach(t => t.classList.remove('active'));
        el.classList.add('active');
        renderGrid();
      });
    });
  }

  function renderGrid() {
    if (!data.chocolates || data.chocolates.length === 0) {
      $grid.innerHTML = '<div class="swz-empty" style="grid-column: 1 / -1;"><strong>No chocolates yet.</strong></div>';
      return;
    }

    const capacity = state.box ? state.box.capacity : 500;
    const currentG = totalG();
    const visible = data.chocolates.filter(c =>
      state.filter === 'all' || c.collection === state.filter
    );

    $grid.innerHTML = visible.map(c => {
      const pieces = state.items[c.variant_id] || 0;
      const oos = !c.available;
      const isPrestige = c.collection === 'prestige';
      const pieceG = (c.grams && c.grams > 0) ? c.grams : 20;
      const stepPieces = piecesForStep(c);
      const stepGrams = stepPieces * pieceG;
      const per100gEGP = formatCurrency(ratePerGram(c) * 100);
      const canAddMore = !oos && (currentG + stepGrams) <= (capacity + (STEP_GRAMS / 2)); // tolerate 50g over
      const currentGrams = pieces * pieceG;

      const imgHtml = c.image
        ? '<img src="' + escapeAttr(c.image) + '" alt="' + escapeAttr(c.title) + '">'
        : '';

      return '<div class="swz-card ' + (pieces > 0 ? 'selected' : '') + (oos ? ' oos' : '') + '" data-id="' + c.variant_id + '">' +
        '<div class="swz-card-img">' +
          imgHtml +
          '<div class="swz-card-pill ' + (isPrestige ? 'prestige' : '') + '">' + (isPrestige ? 'Prestige' : 'Signature') + '</div>' +
          (pieces > 0 ? '<div class="swz-card-qty">~' + currentGrams + 'g</div>' : '') +
          (oos ? '<div class="swz-card-oos">Out of stock</div>' : '') +
        '</div>' +
        '<div class="swz-card-title">' + escapeHtml(c.title) + '</div>' +
        '<div class="swz-card-meta">' + per100gEGP + ' EGP per 100g</div>' +
        '<div class="swz-card-controls">' +
          (pieces > 0 ? '<button class="swz-minus" data-id="' + c.variant_id + '" aria-label="Remove 100g">−</button>' : '') +
          '<button class="swz-plus" data-id="' + c.variant_id + '" ' + (canAddMore ? '' : 'disabled') + ' aria-label="Add 100g">+</button>' +
        '</div>' +
      '</div>';
    }).join('');

    $grid.querySelectorAll('.swz-plus').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.id);
        const c = (data.chocolates || []).find(x => x.variant_id === id);
        if (!c || !c.available) return;
        const pieceG = (c.grams && c.grams > 0) ? c.grams : 20;
        const stepPieces = piecesForStep(c);
        const stepGrams = stepPieces * pieceG;
        const cap = state.box ? state.box.capacity : 500;
        if (totalG() + stepGrams > cap + (STEP_GRAMS / 2)) return;
        state.items[id] = (state.items[id] || 0) + stepPieces;
        renderGrid();
        renderSummary();
      });
    });

    $grid.querySelectorAll('.swz-minus').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.id);
        const c = (data.chocolates || []).find(x => x.variant_id === id);
        if (!c) return;
        const stepPieces = piecesForStep(c);
        const current = state.items[id] || 0;
        if (current > 0) {
          const newQty = Math.max(0, current - stepPieces);
          if (newQty <= 0) delete state.items[id];
          else state.items[id] = newQty;
        }
        renderGrid();
        renderSummary();
      });
    });
  }

  function renderSummary() {
    if (!$grams) return;
    const cap = state.box ? state.box.capacity : 500;
    const g = totalG();
    const p = totalP();
    const n = totalN();
    const pct = Math.min(100, Math.round((g / cap) * 100));

    $grams.textContent = '~' + g + 'g / ' + cap + 'g';
    $count.textContent = n + ' flavour' + (n === 1 ? '' : 's');
    $bar.style.width = pct + '%';
    $total.textContent = formatCurrency(p) + ' EGP';
    $addBtn.disabled = totalPieces() === 0 || !state.box;
  }

  if ($addBtn) {
    $addBtn.addEventListener('click', async () => {
      if (!state.box || totalPieces() === 0) return;

      const cornetId = 'cor_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
      const cornetLabel = 'Your ' + state.box.title + ' cornet';

      const items = [];

      items.push({
        id: state.box.variant_id,
        quantity: 1,
        properties: {
          '_cornet_id': cornetId,
          '_cornet_role': 'box',
          'Cornet': cornetLabel
        }
      });

      Object.entries(state.items).forEach(([id, pieces]) => {
        if (pieces > 0) {
          const c = (data.chocolates || []).find(x => x.variant_id === parseInt(id));
          if (!c) return;
          const pieceG = (c.grams && c.grams > 0) ? c.grams : 20;
          const approxGrams = pieces * pieceG;
          items.push({
            id: parseInt(id),
            quantity: pieces,
            properties: {
              '_cornet_id': cornetId,
              '_cornet_role': 'chocolate',
              'Pieces': pieces,
              'Approx weight': '~' + approxGrams + 'g',
              'Cornet': cornetLabel
            }
          });
        }
      });

      const originalLabel = $addBtn.textContent;
      $addBtn.disabled = true;
      $addBtn.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Cart add failed');
        }
        window.location.href = '/cart';
      } catch (e) {
        console.error('Swiza Cornet — cart add failed', e);
        $addBtn.disabled = false;
        $addBtn.textContent = originalLabel;
        alert('Sorry — something went wrong adding your cornet. ' + (e.message || ''));
      }
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }
  function escapeAttr(str) { return escapeHtml(str); }

  bindTabs();
  renderBoxes();
  renderGrid();
  renderSummary();
})();